const currentDate = new Date();
const monthYear = currentDate.toLocaleString('it-IT', { month: 'long', year: 'numeric' });
const formattedMonth = monthYear.charAt(0).toUpperCase() + monthYear.slice(1, -5);
const formattedYear = currentDate.getFullYear();

export const getFormattedMonthYear = () => {
  return { formattedMonth, formattedYear };
};

export const replaceDatePlaceholders = (text) => {
  if (!text) return null; // Fallback se il testo è null o undefined
  return text.replace('{{month}}', formattedMonth).replace('{{year}}', String(formattedYear));
};
